import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  static targets = ["actions", "optionsContainer", "option"];

  connect() {
    this.scrollArrowsShown = false;
  }

  showOptions() {
    if (this.hasOptionsContainerTarget) {
      this.optionsContainerTarget.classList.add("show-options");
    }
    if (this.hasActionsTarget) {
      this.actionsTarget.classList.add("show-actions");
    }
    this.revealScrollArrowsAfterAnimation();
  }

  async selectOption(event) {
    event.preventDefault();
    const { currentTarget } = event;
    if (!currentTarget) return;

    // Check if this is an old product option that should open deeplink
    const productUrl = currentTarget.dataset.productUrl;
    if (productUrl && this.isOldProductSection()) {
      window.open(productUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    this.optionTargets.forEach((element) => element.classList.remove("selected"));
    currentTarget.classList.add("selected");

    // Only disable options for non-product sections.
    // Product sections stay clickable - backend handles disabling via deepLinkMode on re-render.
    if (!this.element.dataset.outletAllowManipulationValue) {
      this.disableOptions();
    }

    const url = currentTarget.dataset.hhref || currentTarget.dataset.href;
    if (!url || url === "#") return;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        credentials: "include",
      });

      if (!response.ok) {
        this.emitGlobalXhrFailed(response.status);
      }
    } catch (error) {
      console.error("OutletController select failed", error);
      this.emitGlobalXhrFailed();
    }
  }

  isOldProductSection() {
    // Only applies to sections with allow-manipulation (product sections)
    if (!this.element.dataset.outletAllowManipulationValue) return false;

    const conversation = document.getElementById('conversation');
    if (!conversation) return false;

    // Find all product option sections
    const productSections = conversation.querySelectorAll(
      '[data-outlet-allow-manipulation-value="true"]'
    );
    if (productSections.length <= 1) return false;

    // Is this section NOT the last product section?
    const lastProductSection = productSections[productSections.length - 1];
    return this.element !== lastProductSection;
  }

  disableOptions() {
    this.optionTargets.forEach((option) => {
      option.disabled = true;
    });

    this.element.querySelectorAll("button").forEach((button) => {
      button.disabled = true;
    });
  }

  revealScrollArrowsAfterAnimation() {
    if (!this.optionsContainerTarget || this.scrollArrowsShown) return;
    const options = this.optionsContainerTarget.querySelectorAll(".option");
    const lastOption = options.length ? options[options.length - 1] : null;
    if (!lastOption) return;

    const scrollWrapper = this.optionsContainerTarget.closest(".scroll-wrapper");
    if (!scrollWrapper) return;

    const addClass = () => {
      scrollWrapper.classList.add("show-scroll-arrows");
      this.scrollArrowsShown = true;
    };

    const onEnd = () => {
      addClass();
      lastOption.removeEventListener("transitionend", onEnd);
    };

    lastOption.addEventListener("transitionend", onEnd, { once: true });

    window.setTimeout(addClass, 600);
  }

  emitGlobalXhrFailed(status = null) {
    window.dispatchEvent(new CustomEvent("xhr-failed", { detail: { status } }));
  }
}
